import { render, staticRenderFns } from "./Workouts.vue?vue&type=template&id=73ddb842&scoped=true"
import script from "./Workouts.vue?vue&type=script&lang=js"
export * from "./Workouts.vue?vue&type=script&lang=js"
import style0 from "./Workouts.vue?vue&type=style&index=0&id=73ddb842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ddb842",
  null
  
)

export default component.exports